import { apiMaybe, apiRequest } from '../../services/apiClient';

export function buildContractSearchQuery(params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === '') return;
    searchParams.set(key, String(value));
  });

  return searchParams.toString();
}

export function getContractFacets() {
  return apiMaybe('/contracts/facets');
}

export function getContractTypes() {
  return apiMaybe('/enums/contract-types');
}

export function matchCounterpartyName(name) {
  return apiMaybe(`/contracts/counterparty-match?name=${encodeURIComponent(name)}`);
}

export function searchContracts(params = {}, { required = false } = {}) {
  const query = buildContractSearchQuery(params);
  const request = required ? apiRequest : apiMaybe;
  return request(`/contracts/search${query ? `?${query}` : ''}`);
}

export function contractTypesToOptions(contractTypes, placeholder = null) {
  const options = Array.isArray(contractTypes)
    ? contractTypes.map((contractType) => ({ value: contractType, label: contractType }))
    : [];
  return placeholder ? [placeholder, ...options] : options;
}

export function counterpartyGroupsToOptions(counterpartyGroups, placeholder = null) {
  const options = Array.isArray(counterpartyGroups)
    ? counterpartyGroups.map((group) => ({
      value: group.name,
      label: `${group.name} (${group.count})`,
    }))
    : [];
  return placeholder ? [placeholder, ...options] : options;
}

export function tagsToOptions(tags, placeholder = null) {
  const options = Array.isArray(tags)
    ? tags.map((tag) => ({ value: tag, label: tag }))
    : [];
  return placeholder ? [placeholder, ...options] : options;
}
